import { render, staticRenderFns } from "./Stepper.vue?vue&type=template&id=be804746&scoped=true"
import script from "./Stepper.vue?vue&type=script&lang=js"
export * from "./Stepper.vue?vue&type=script&lang=js"
import style0 from "./Stepper.vue?vue&type=style&index=0&id=be804746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be804746",
  null
  
)

export default component.exports